import { ReactNode, useMemo } from 'react'
import { OverviewTile } from '../defaults'
import TileRenderer from './TileRenderer'
import { OverviewContext } from '../context'

interface OverviewContentProps {
  mainTiles: OverviewTile[]
  sidebarTiles: OverviewTile[]
  isCustomizing: boolean
  sidebarContent?: ReactNode
}

const Overview = ({
  mainTiles,
  sidebarTiles,
  isCustomizing,
  sidebarContent,
}: OverviewContentProps) => {
  const displayMainTiles = useMemo(
    () => mainTiles.filter((t) => isCustomizing || !t._destroy),
    [mainTiles, isCustomizing],
  )

  const displaySidebarTiles = useMemo(
    () => sidebarTiles.filter((t) => isCustomizing || !t._destroy),
    [sidebarTiles, isCustomizing],
  )

  const content =
    sidebarTiles.length > 0 || sidebarContent ? (
      <div className='grid grid-cols-1 lg:grid-cols-4 gap-4'>
        <div className='lg:col-span-3 space-y-4'>
          {displayMainTiles.map((tile, index) => (
            <TileRenderer
              key={tile.id || `main-${index}`}
              tile={tile}
              index={index}
            />
          ))}
        </div>

        <div className='space-y-4'>
          {sidebarContent}
          {displaySidebarTiles.map((tile, index) => (
            <TileRenderer
              key={tile.id || `sidebar-${index}`}
              tile={tile}
              index={index}
            />
          ))}
        </div>
      </div>
    ) : (
      <div className='flex flex-col gap-4'>
        {displayMainTiles.map((tile, index) => (
          <TileRenderer
            key={tile.id || `main-${index}`}
            tile={tile}
            index={index}
          />
        ))}
      </div>
    )

  if (isCustomizing) {
    return content
  }

  return (
    <OverviewContext.Provider
      value={{
        isCustomizing: false,
        isPending: false,
        onEditTile: () => undefined,
      }}
    >
      {content}
    </OverviewContext.Provider>
  )
}

export default Overview
